import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'antd';

import Weight from 'components/controls/Weight';
import 'pages/Project/Risks/Tabs/OptionsTab.sass';

interface ColumnsDisplayTabProps {
	// Sous-arbre de préférences de la page (ex. preferences.pages.stakes)
	preferences: any;
	// (key, value) -> persiste la préférence de la page
	setPreferences: (key: string, value: any) => void;
	// Faux en mode Visualisation (pas de tableau) -> masque la section
	// « Colonnes affichées », sans objet en viz. Défaut vrai.
	displayColumns?: boolean;
	// Affiche le toggle « Catégorie » (pages avec colonne catégorie,
	// ex. Indicateurs). Préférence `category` (défaut vrai).
	showCategoryToggle?: boolean;
}

// Onglet "Affichage" (mode non sélectionné) : section "Colonnes affichées"
// avec le toggle "Afficher la description". Même pattern que Risks/OptionsTab
// (contrôle Weight 1/0, préférence persistée via UIProvider).
export const ColumnsDisplayTab = (props: ColumnsDisplayTabProps) => {
	const { t } = useTranslation();

	const isDescriptionVisible =
		props.preferences?.description !== undefined
			? props.preferences?.description
			: true;

	const displayColumns =
		props.displayColumns !== undefined ? props.displayColumns : true;

	return (
		<div className="OptionsTab">
			{displayColumns && (
				<>
					<strong className="text-left mt-1" style={{ marginBottom: '0.5rem' }}>
						{t('pages.risks.tabs.filters.displayed_columns')}
					</strong>
					<div className="columnsList">
						<Flex className="mb-05 text-left">
							<div style={{ width: '95%' }}>
								{t('pages.risks.tabs.options.show_description', {
									defaultValue: 'Afficher la description'
								})}
							</div>
							<Weight
								count={1}
								onClick={() => {
									props.setPreferences(
										'description',
										!isDescriptionVisible
									);
								}}
							>
								{isDescriptionVisible ? 1 : 0}
							</Weight>
						</Flex>
						{props.showCategoryToggle && (
							<Flex className="mb-05 text-left">
								<div style={{ width: '95%' }}>
									{t('models.indicator.fields.indicator_category')}
								</div>
								<Weight
									count={1}
									onClick={() => {
										props.setPreferences(
											'category',
											!(props.preferences?.category !== false)
										);
									}}
								>
									{props.preferences?.category !== false ? 1 : 0}
								</Weight>
							</Flex>
						)}
					</div>
				</>
			)}
		</div>
	);
};

export default ColumnsDisplayTab;
